import { render } from "./LinkIcon.vue?vue&type=template&id=51960547"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__